import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useState } from "react";
import Slide from "@material-ui/core/Slide";
import { Skeleton } from "@material-ui/lab";
import ControleAcessoService from "../../../services/ControleAcessoService";
import webconfig from "../../../webconfig.json";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

export default function DialogRevogar({
    dialogRevogar,
    setDialogRevogar,
    setAtualizarConsulta,
    setFoiRevogacao
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setDialogRevogar((prevState) => ({
            id: prevState.id,
            open: false,
            delete: prevState.delete,
        }));
    };

    const handleRevogar = async () => {
        setLoading(true);

        await ControleAcessoService.Revogar(dialogRevogar.id)
            .then(response => {
                setLoading(false)
                enqueueSnackbar(`${response.data}`, { variant: "success", autoHideDuration: webconfig.snackbarAutoHideDuration })
                handleClose();
                setFoiRevogacao(true)
                setAtualizarConsulta(new Date().toLocaleString())
            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            });
    };

    return (
        <Dialog
            open={dialogRevogar.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => (loading ? "" : handleClose())}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
            id='dialog-crud-assunto'
        >
            <DialogTitle id='alert-dialog-slide-title' className='txt-primario'>
                {"Revogar Acesso"}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {loading ? (
                                <Skeleton variant='rect' width={"100%"} height={22} />
                            ) : (
                                <>
                                    <Typography variant='h6'>
                                        Deseja realmente revogar o acesso?{" "}
                                    </Typography>
                                </>
                            )}
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    className='bg-alternativo-4 txt-alternativo-3'
                    disabled={loading}
                >
                    Cancelar
                </Button>
                <Button
                    className='bg-primario txt-branco btn-salvar-default btn-excluir-default'
                    disabled={loading}
                    onClick={() => handleRevogar()}
                >
                    {loading ? <CircularProgress size={22} /> : "Revogar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
